/*
 * @Descripttion: 发票录入页hooks
 * @Author: cb4786
 * @Date: 2023-08-10 17:06:46
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-01 13:59:47
 */
import { useEffect, useReducer } from 'react'
import { useDispatch } from 'react-redux'
import { setModuleDataAction } from '../../modules/pagecache'
import { history, useTypedSelector } from '../../redux/store'
import { OrderType } from '../../tools/public'
import { getSupplierId, isResponseCodeSuccess } from '../../tools/util'
import { GET_ACCOUNT_PAYMENT_COUNT } from '../../api/orderManage'
import { usePermissionStore } from '@/stores/permission'
import { useInvoiceEntryStore } from '@/stores/invoiceEntryStore'

interface State {
  checkedOrderKey: OrderType
}
type ActionType = 'setCheckedOrderKey' | 'changedataAction'
interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  checkedOrderKey: 'CUSTOMER',
}

const reducer = (state: State, action: Action): State => {
  let newstate = { ...state }
  switch (action.type) {
    case 'changedataAction':
      newstate = action.payload
      return newstate
    case 'setCheckedOrderKey':
      newstate.checkedOrderKey = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置当前选中订单 tab的key值
 * @param key
 * @returns
 */
const setCheckedOrderKey = (val: string): Action => ({
  type: 'setCheckedOrderKey',
  payload: val,
})

const changedataAction = (param: State): Action => ({
  type: 'changedataAction',
  payload: param,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const { checkedOrderKey } = state
  const permissionList = usePermissionStore((state) => state.permissionList)
  const landerInvoiceCount = useInvoiceEntryStore(
    (state) => state.landerInvoiceCount,
  )
  const supplierInvoiceCount = useInvoiceEntryStore(
    (state) => state.supplierInvoiceCount,
  )
  const orderCount = {
    CUSTOMER: landerInvoiceCount,
    SUPPLIER: supplierInvoiceCount,
  }
  const dispatchredux = useDispatch()
  useEffect(() => {
    // 从 URL 参数中读取 tab 值（待办中心跳转时传入）
    const searchParams = new URLSearchParams(history.location.search)
    const tabFromUrl = searchParams.get('tab')

    const flag = getpagecache()
    if (tabFromUrl === 'CUSTOMER' || tabFromUrl === 'SUPPLIER') {
      // 待办中心跳转过来，强制切换到指定 tab
      dispatch(setCheckedOrderKey(tabFromUrl))
      getOrderCount(false)
    } else if (flag) {
      const action = changedataAction(flag)
      dispatch(action)
      // 非首次进入页面时只需要刷新tab对应订单数，不改变tab选中值
      getOrderCount(false)
    } else {
      getOrderCount(true)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: JSON.parse(JSON.stringify(state)),
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 获取电商供应商可开票订单和供应商可开票订单数
  const getOrderCount = async (changeTab: boolean) => {
    const res = await GET_ACCOUNT_PAYMENT_COUNT({
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      const data = {
        CUSTOMER: res.data.openInvoiceCount,
        SUPPLIER: res.data.supplierOrderOpenInvoiceCount,
      }
      // setLanderInvoiceCount(data.CUSTOMER)
      // setSupplierInvoiceCount(data.SUPPLIER)
      // 首次进入页面判断默认选中的tab
      if (changeTab) {
        if (permissionList.includes('自营供应商')) {
          dispatch(setCheckedOrderKey('SUPPLIER'))
        } else if (permissionList.includes('电商供应商')) {
          dispatch(setCheckedOrderKey('CUSTOMER'))
        } else {
          // 既是供应商又是电商供应商，判断订单数决定默认选中的tab
          if (
            Object.values(data).every((item) => item === 0) ||
            Object.values(data).every((item) => item > 0)
          ) {
            dispatch(setCheckedOrderKey('CUSTOMER'))
            // 只存在供应商订单数
          } else if (data.SUPPLIER > 0 && data.CUSTOMER === 0) {
            dispatch(setCheckedOrderKey('SUPPLIER'))
          }
        }
      }
    }
  }

  const changeOrder = (key: string) => {
    dispatch(setCheckedOrderKey(key))
  }
  return {
    changeOrder,
    checkedOrderKey,
    orderCount,
    permissionList,
  }
}
/*
 * @Descripttion: 发票录入页hooks
 * @Author: cb4786
 * @Date: 2023-08-10 17:06:46
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-01 13:59:47
 */
import { useEffect, useReducer } from 'react'
import { useDispatch } from 'react-redux'
import { setModuleDataAction } from '../../modules/pagecache'
import { history, useTypedSelector } from '../../redux/store'
import { OrderType } from '../../tools/public'
import { getSupplierId, isResponseCodeSuccess } from '../../tools/util'
import { GET_ACCOUNT_PAYMENT_COUNT } from '../../api/orderManage'
import { usePermissionStore } from '@/stores/permission'
import { useInvoiceEntryStore } from '@/stores/invoiceEntryStore'

interface State {
  checkedOrderKey: OrderType
}
type ActionType = 'setCheckedOrderKey' | 'changedataAction'
interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  checkedOrderKey: 'CUSTOMER',
}

const reducer = (state: State, action: Action): State => {
  let newstate = { ...state }
  switch (action.type) {
    case 'changedataAction':
      newstate = action.payload
      return newstate
    case 'setCheckedOrderKey':
      newstate.checkedOrderKey = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置当前选中订单 tab的key值
 * @param key
 * @returns
 */
const setCheckedOrderKey = (val: string): Action => ({
  type: 'setCheckedOrderKey',
  payload: val,
})

const changedataAction = (param: State): Action => ({
  type: 'changedataAction',
  payload: param,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const { checkedOrderKey } = state
  const permissionList = usePermissionStore((state) => state.permissionList)
  const landerInvoiceCount = useInvoiceEntryStore(
    (state) => state.landerInvoiceCount,
  )
  const supplierInvoiceCount = useInvoiceEntryStore(
    (state) => state.supplierInvoiceCount,
  )
  const orderCount = {
    CUSTOMER: landerInvoiceCount,
    SUPPLIER: supplierInvoiceCount,
  }
  const dispatchredux = useDispatch()
  useEffect(() => {
    // 从 URL 参数中读取 tab 值（待办中心跳转时传入）
    const searchParams = new URLSearchParams(history.location.search)
    const tabFromUrl = searchParams.get('tab')

    const flag = getpagecache()
    if (tabFromUrl === 'CUSTOMER' || tabFromUrl === 'SUPPLIER') {
      // 待办中心跳转过来，强制切换到指定 tab
      dispatch(setCheckedOrderKey(tabFromUrl))
      getOrderCount(false)
    } else if (flag) {
      const action = changedataAction(flag)
      dispatch(action)
      // 非首次进入页面时只需要刷新tab对应订单数，不改变tab选中值
      getOrderCount(false)
    } else {
      getOrderCount(true)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: JSON.parse(JSON.stringify(state)),
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 获取电商供应商可开票订单和供应商可开票订单数
  const getOrderCount = async (changeTab: boolean) => {
    const res = await GET_ACCOUNT_PAYMENT_COUNT({
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      const data = {
        CUSTOMER: res.data.openInvoiceCount,
        SUPPLIER: res.data.supplierOrderOpenInvoiceCount,
      }
      // setLanderInvoiceCount(data.CUSTOMER)
      // setSupplierInvoiceCount(data.SUPPLIER)
      // 首次进入页面判断默认选中的tab
      if (changeTab) {
        if (permissionList.includes('自营供应商')) {
          dispatch(setCheckedOrderKey('SUPPLIER'))
        } else if (permissionList.includes('电商供应商')) {
          dispatch(setCheckedOrderKey('CUSTOMER'))
        } else {
          // 既是供应商又是电商供应商，判断订单数决定默认选中的tab
          if (
            Object.values(data).every((item) => item === 0) ||
            Object.values(data).every((item) => item > 0)
          ) {
            dispatch(setCheckedOrderKey('CUSTOMER'))
            // 只存在供应商订单数
          } else if (data.SUPPLIER > 0 && data.CUSTOMER === 0) {
            dispatch(setCheckedOrderKey('SUPPLIER'))
          }
        }
      }
    }
  }

  const changeOrder = (key: string) => {
    dispatch(setCheckedOrderKey(key))
  }
  return {
    changeOrder,
    checkedOrderKey,
    orderCount,
    permissionList,
  }
}
